// import { computed, observable, extendObservable, action, autorun } from 'mobx';
import Relation from './Relation';

/**
 * Обраотка все связей типа hasMany (hasAndBelongsToMany)
 */
export default class HasMany extends Relation {

	/**
	 * Кэш
	 */
	_cache;

	/**
	 * Создание новой связи
	 * @param model Модель
	 * @param targetModel Модель на которую ссылается model
	 * @param relation Информация о связи
	 * @param instance Объект, если не указан считается что это связь между моделями
	 */
	constructor (model, targetModel, relation, instance) {
		super (model, targetModel, relation, instance);

		let methods = model.INFO.methods;
		let relationMethods = {};
		let self = this;

		methods && Object.keys (methods).forEach (methodFullName => {
			let [, methodName, relationName] = methodFullName.split ('__');
			let method = Relation.METHODS[methodName];

			if (relationName === relation.name) {
				if (methodName === 'get') {
					self._getMethod = methods[methodFullName];
				}
				relationMethods[method || methodName] = function () {
					if (method.accessType !== 'READ') {
						delete self._cache;
					}
					return self._instance[methodFullName].apply(self._instance, arguments);
				}


			}
		});

		this.get = function () {
			if (self._cache === undefined) {
				self._cache = self.find.apply(self, arguments);
			}

			return self._cache;
		};

		Object.assign (this, relationMethods);
		Object.assign (this.get, relationMethods);
	}

	set (value) {
		this._cache = this._targetModel.PROCESS_RESULT(this._getMethod, value);
	}
}
